import {
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'RunFlatToggle',
  components: {},
  props: {},
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      runFlat: 'getRunFlat',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setRunFlatMutation: 'SET_RUNFLAT',
    }),
    setRunFlat(isRunFlat) {
      this.setRunFlatMutation(isRunFlat);
    },
  },
};
